/**
 * UPI price line (payment_signals block, sections/main-product.liquid).
 *
 * The line reads "Rs. 11,519 with UPI": the chosen variant's price less the
 * UPI discount, rounded down to the whole rupee as the checkout does. Liquid
 * prints it for the first variant; this keeps it true when a shopper picks
 * another, by listening for the `variant:changed` event variant-picker.js
 * announces - whose detail carries price_amount in the smallest unit.
 *
 * Formatting follows the shop's own money format ({{amount}} and its
 * variants), so the line matches every other price on the page.
 */
(function () {
  function group(n, sep) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function format(cents, template) {
    var whole = Math.floor(cents / 100);
    var frac = ('0' + (cents % 100)).slice(-2);
    var amounts = {
      amount: group(whole, ',') + '.' + frac,
      amount_no_decimals: group(whole, ','),
      amount_with_comma_separator: group(whole, '.') + ',' + frac,
      amount_no_decimals_with_comma_separator: group(whole, '.')
    };
    return (template || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      return amounts[key] !== undefined ? amounts[key] : amounts.amount;
    });
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || typeof variant.price_amount !== 'number') return;

    document.querySelectorAll('[data-upi-price]').forEach(function (el) {
      var percent = parseFloat(el.dataset.upiPercent);
      if (!percent) return;
      var cents = Math.floor((variant.price_amount * (100 - percent)) / 100 / 100) * 100;
      el.textContent = format(cents, el.dataset.moneyFormat);
    });
  });
})();
